<main [class.darkmode]="dark_mode">
    <!-- Showing All Site Pages -->
    <app-layout *ngIf = "isLogged()" style="height:100%"></app-layout>
    <!-- <app-login *ngIf = "!isLogged() && classic_login"></app-login> -->
    <new-app-login *ngIf = "!isLogged() && login_selected === 'ADMIN'"></new-app-login> 

    <auslroma-login *ngIf="!isLogged() && login_selected === 'AUSLROMA'">

    </auslroma-login>

    <auslroma-ldap-login  *ngIf="!isLogged() && login_selected === 'AUSLROMALDAP'">

    </auslroma-ldap-login>
    
    <div style="text-align:center;" *ngIf="user_migrating">
        {{ 'users.user_migrating' | translate }}
    </div>
    
</main>
